import { PoolActions, PoolStateType } from './poolTypes';

const poolReducer = (state: PoolStateType, action: PoolActions): PoolStateType => {
    switch (action.type) {
        case 'SET_SELECTED_POOL':
            return {
                ...state,
                selectedLiquidityPool: action.payload,
            };
        case 'TOGGLE_DEPOSIT_INTERFACE':
            return {
                ...state,
                renderDepositInterface: !state.renderDepositInterface,
            };
        case 'TOGGLE_WITHDRAW_INTERFACE':
            return {
                ...state,
                renderWithdrawInterface: !state.renderWithdrawInterface,
            };
        case 'TOGGLE_EXPOSURE':
            return {
                ...state,
                renderExposure: !state.renderExposure,
            };
        case 'SET_SELECTED_LOCK_UP':
            return {
                ...state,
                selectedLockUp: action.payload,
            };
        case 'SET_DEPOSIT_AMOUNT':
            return {
                ...state,
                depositAmount: action.payload,
            };
        case 'SET_WITHDRAW_AMOUNT':
            return {
                ...state,
                withdrawAmount: action.payload,
            };
        case 'RESET_POOL_STATE':
            return {
                ...state,
                depositAmount: '',
                withdrawAmount: '',
                selectedLockUp: {
                    duration: undefined,
                    feeMultiplier: undefined,
                    lockUpId: undefined,
                },
            };
        default:
            return state;
    }
};

export default poolReducer;
